import { useTheme } from '@mui/material/styles';
import DrawerHeaderStyled from './DrawerHeaderStyled';
import Logo from '../../../../components/logo';
import { FC } from 'react';

interface Props {
	open: boolean;
}

const DrawerHeader: FC<Props> = ({ open }) => {
	const theme = useTheme();

	return (
		<DrawerHeaderStyled
			theme={theme}
			open={open}
			sx={{
				minHeight: 0,
				width: 'inherit',
				paddingTop: 3.5,
				paddingBottom: 3.5,
				paddingLeft: open ? 2.5 : 0,
			}}
		>
			<Logo sx={{ lineHeight: 1 }} />
		</DrawerHeaderStyled>
	);
};

export default DrawerHeader;
